import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { StyleSheet, css } from 'aphrodite';
import { Theme } from '../../config/theme';

import ConditionsModal from '../ConditionsModal';

export default class SubscriptionCard extends Component {
  constructor(props) {
    super(props);
    this.toggleConditions = this.toggleConditions.bind(this);
    this.state = {
      showConditions: false,
    };
  }

  toggleConditions() {
    this.setState({
      showConditions: !this.state.showConditions,
    });
  }

  render() {
    return (
      <div
        role="button"
        tabIndex={0}
        className={css(
          styles.card,
          this.props.selected === this.props.id ? styles.card_selected : null,
        )}
        onClick={() => this.props.handleSelect(this.props.id)}
      >
        <img className={css(styles.icon)} src={this.props.icon} alt={this.props.title} />
        <h2 className={css(styles.title)}>{this.props.title}</h2>
        <span className={css(styles.includes_label)}>Includes</span>
        <ul className={css(styles.includes)}>
          {this.props.includes.map(include =>
            <li key={include} className={css(styles.includes_item)}>{include}</li>,
          )}
        </ul>
        <div className={css(styles.price)}>
          ${this.props.promoPrice !== null ?
            this.props.promoPrice.toFixed(2) : this.props.price.toFixed(2)}
        </div>
        {this.props.promoText ?
          <div className={css(styles.promo)}>
            {this.props.promoTitle ?
              <span className={css(styles.promo_title)}>{this.props.promoTitle}</span>
            : null}
            {this.props.promoText}
          </div>
        : null}
        <div
          role="button"
          tabIndex={0}
          className={css(styles.conditions)}
          onClick={this.toggleConditions}
          >
          See conditions
        </div>
        <ConditionsModal open={this.state.showConditions} toggle={this.toggleConditions}>
          {this.props.conditions}
        </ConditionsModal>
      </div>
    );
  }
}

SubscriptionCard.defaultProps = {
  promoPrice: null,
  promoText: null,
  promoTitle: null,
};

SubscriptionCard.propTypes = {
  id: PropTypes.string.isRequired,
  selected: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  includes: PropTypes.arrayOf(PropTypes.string).isRequired,
  price: PropTypes.number.isRequired,
  // conditions: PropTypes.objectOf(PropTypes.node).isRequired,
  handleSelect: PropTypes.func.isRequired,
  conditions: PropTypes.string.isRequired,
  promoPrice: PropTypes.number,
  promoTitle: PropTypes.string,
  promoText: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node).isRequired,
    PropTypes.object,
  ]),
};

const styles = StyleSheet.create({
  card: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: 422,
    padding: '38px 12px 0',
    margin: '0 15px',
    textAlign: 'center',
    color: Theme.black,
    backgroundColor: Theme.white,
    boxShadow: '0 3px 4px 0 rgba(171, 171, 171, 0.5), 0 0 0 0 #39b4d6',
    border: 'solid 1px #e4e4e4',
    transition: 'all 300ms',
    outline: 'none',
    cursor: 'pointer',

    [Theme.mobile_query]: {
      width: '100%',
      margin: '0 0 30px',
    },
  },

  promo: {
    width: 422,
    margin: '0 -12px',
    padding: '15px',
    textAlign: 'center',
    color: '#fff',
    fontSize: 14,
    lineHeight: 1.4,
    backgroundColor: '#021a36',

    [Theme.mobile_query]: {
      width: 'auto',
    },

    ':not(.a) strong': {
      fontWeight: 'bold',
    },
  },
  promo_title: {
    display: 'block',
    textTransform: 'uppercase',
    fontWeight: 'bold',
    marginBottom: 5,
    fontSize: 13,
    letterSpacing: 0.65,
  },

  card_selected: {
    borderColor: 'transparent',
    boxShadow: '0 3px 4px 0 rgba(171, 171, 171, 0.2), 0px 0px 6px 4px #39b4d6',
    [Theme.mobile_query]: {
      boxShadow: '0 3px 4px 0 rgba(171, 171, 171, 0.2), 0px 0px 6px 4px #39b4d6',
    },
  },

  icon: {
    height: 132,
    width: 132,
    borderRadius: '50%',
    marginBottom: 16.5,
    color: 'transparent',
  },

  title: {
    marginBottom: 24.5,
    padding: '0 92px',
    fontSize: 30,
    fontFamily: Theme.font_family_heading,
    fontWeight: Theme.font_weight_heading,

    [Theme.mobile_query]: {
      padding: '0 30px',
    },
  },

  includes_label: {
    display: 'block',
    width: '100%',
    paddingTop: 19,
    marginBottom: 10,
    fontFamily: Theme.font_family_secondary,
    fontWeight: Theme.font_weight_secondary,
    letterSpacing: 1.8,
    lineHeight: 2,
    color: '#a5a5a5',
    fontSize: 13,
    textTransform: 'uppercase',
    borderTop: '1px solid #ddd',
  },

  includes: {
    padding: '0 21px',
    marginBottom: 25,
  },

  includes_item: {
    lineHeight: 1.4,
    fontSize: 15,
    fontFamily: Theme.font_family_primary,
    fontWeight: Theme.font_weight_primary,

    ':not(:last-child)': {
      marginBottom: 15,
    },
  },

  price: {
    marginBottom: 30,
    fontSize: 45,
    fontFamily: Theme.font_family_heading,
    fontWeight: Theme.font_weight_heading,
  },

  conditions: {
    height: 70,
    width: '100%',
    lineHeight: '70px',
    fontSize: 15,
    fontFamily: Theme.font_family_secondary,
    fontWeight: Theme.font_weight_secondary,
    textTransform: 'uppercase',
    letterSpacing: 2,
    color: '#39b4d6',
    borderTop: '1px solid #ddd',
    outline: 'none',
    cursor: 'pointer',
  },
});



// WEBPACK FOOTER //
// ./src/components/SubscriptionCard/index.js